<div class="container py-4">

  <!-- 🔷 TÍTULO -->


  <!-- 🟥 BANNER -->
  <div class="banner-ia">
    <div class="banner-left">
      <img src="assets/banners_carreras/INDUSTRIAS.jpg" alt="IA">
    </div>
  </div>

  <!-- 📘 INFO PRINCIPAL -->
  <section class="info-section">

    <div class="info-block">
      <h3>■ OBJETIVO GENERAL</h3>
      <p>
        Formar ingenieros en Industrias Alimentarias con sólidos conocimientos científicos y tecnológicos,
        para desarrollar, mejorar y producir alimentos inocuos e innovadores; bajo un esquema ético y
        sustentable acorde a las necesidades de la sociedad en el ámbito regional, nacional e internacional.
      </p>
    </div>



    <div class="info-block">
      <h3>■ MISIÓN</h3>
      <p>
        Formar profesionistas para la Industria Agroalimentaria con perfil innovador, liderazgo y ética, capaces de
        transformar, analizar, desarrollar productos y sistemas alimentarios; bajo un marco sustentable que satisfaga el
        desarrollo científico- tecnológico de la región.
      </p>
    </div>

    <div class="info-block">
      <h3>■ VISIÓN</h3>
      <p>
        Ser la carrera líder de profesionistas altamente reconocidos dentro del estado, en la solución de necesidades en
        los sectores económicos, social y tecnológico.
      </p>
    </div>

  </section>

  <!-- 🧠 TABS -->
  <div class="tabs-box">

    <ul class="nav nav-tabs">
      <li class="nav-item">
        <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#tab1">
          1. Objetivo especialidad
        </button>
      </li>

      <li class="nav-item">
        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab2">
          2. Perfil de Egreso
        </button>
      </li>

      <!--    <li class="nav-item">
        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab3">
          3. Acreditacion
        </button>
      </li>

      <li class="nav-item">
        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab4">
          4. Información del Personal
        </button>
      </li> -->
    </ul>

    <div class="tab-content">

      <!-- TAB 1 -->
      <div id="tab1" class="tab-pane fade show active">

        <p>El/la estudiante conoce, identifica y aplica los conocimientos de la
          normatividad y operatividad en la industria alimentaria basándose en la ciencia y
          tecnología de los alimentos.</p>

        <ul>
          <li> Comprende las bases bioquímicas, microbiológicas y genéticas que implica la
            producción de alimentos, metabolitos y aditivos de interés para la industria
            alimentaria, con la finalidad de mejorar o desarrollar procesos de manera
            eficiente y sostenible.
          </li>
          <li>Comprende la dimensión ética, social y económica de la aplicación de la
            biotecnología alimentaria y forjar un criterio fundamentado con argumentos
            sólidos respecto al uso de las nuevas tecnologías.</li>
          <li> Comprende los fundamentos estadísticos del diseño de experimentos y los aplica
            para optimizar procesos científicos, tecnológicos e industriales de la
            Ingeniería Alimentaria.
          </li>
          <li> Conoce e identifica los principios de la ciencia y tecnología de los envases
            para garantizar la calidad e inocuidad de los productos procesados en la
            industria alimentaria.
          </li>
          <li>Evalúa el funcionamiento de un sistema de empaque y embalaje en pro del
            desarrollo sustentable.</li>
          <li> Adquiere los conocimientos, fortalece habilidades y genera estrategias en
            relación a la seguridad agroalimentaria por medio de aplicación de metodologías
            de trazabilidad para productos agroalimentarios. </li>
          <li>Conoce, identifica y domina los fundamentos normativos de legislación, inocuidad
            agroalimentaria y seguridad alimentaria para el control de las enfermedades
            transmitidas por los alimentos durante el proceso dentro y fuera de la industria
            alimentaria para su control de calidad e inocuidad del producto. </li>
        </ul>
      </div>

      <!-- TAB 2 -->
      <div id="tab2" class="tab-pane fade">

        <ul>
          <li>Evalúa sistemas de producción para satisfacer los requerimientos de la industria alimentaria,
            considerando aspectos de factibilidad y sustentabilidad.</li>
          <li>Aplica e innova técnicas tradicionales y emergentes para la conservación de los alimentos.</li>
          <li>Selecciona empaques para preservar y comercializar alimentos. </li>
          <li>Inspecciona, controla y evalúa procesos, equipo e instalaciones para asegurar la inocuidad y calidad
            en la industria alimentaria. </li>
          <li>Aplica herramientas estadísticas para la toma de decisiones en la industria alimentaria.</li>
          <li>Conoce sistemas de gestión para cumplir con la normatividad nacional e internacional en la
            industria alimentaria. </li>
          <li>Aplica métodos de análisis para la estandarización de procesos y caracterización de productos en la
            industria alimentaria. </li>
          <li>Transfiere tecnologías para la transformación de alimentos</li>
          <li>Desarrolla nuevos productos para incrementar su valor agregado en la industria alimentaria.</li>
          <li> Desarrolla tecnologías para el aprovechamiento de subproductos alimentarios. </li>
          <li>Desarrolla proyectos para la creación de empresas de alimentos. </li>
          <li>Diseña e imparte cursos de capacitación referentes a tópicos de la industria alimentaria en general. </li>
          <li> Desarrolla habilidades de liderazgo, emprendedora, trabajo ínter- y multidisciplinario,
            comunicación oral y escrita para el desempeño profesional.</li>
          <li>Conoce y aplica un segundo idioma para el desarrollo de su profesión.</li>
        </ul>
      </div>


      <!--      <div id="tab3" class="tab-pane fade">
        <h4>Comité Mexicano de Acreditación de la Educación Agronómica, A.C. (29 enero 2021-28 enero 2026)</h4>
            <br>
           <div class="tab-image-wrapper">
            
          <img src="assets/banners_carreras/Logo COMEAA.jpg" alt="Información de la carrera" class="tab-image">
        </div> -->

      <!--      </div>

     
      <div id="tab4" class="tab-pane fade">
        <h5>Personal Responsable</h5>
        <p><strong>Nombre:</strong> Ing. Manuel de Atocha Barrancos Martínez</p>
        <p><strong>Correo:</strong> divisionisc@itsescarcega.edu.mx</p>
      </div> -->

    </div>
  </div>

  <!--DOCUMENTACIÓN -->
  <div class="doc-section text-center">
    <img src="assets/banners_carreras/logo_drive.png" class="doc-icon">
    <br>
    <a href="https://drive.google.com/drive/u/0/folders/1aIcFn_fktpiSUQOAjC_8UH9J8ow78SNF" target="_blank"
      class="doc-link">
      ■ DOCUMENTACIÓN INGENIERÍA EN INDUSTRIAS ALIMENTARIAS
    </a>
  </div>

  <hr>


  <div class="btn-section">
    
    <a href="assets/reticulas/Malla curricular_IIA (Actual)Proxima a liquidar.pdf" target="_blank" class="btn-doc">
      📊 Retícula
    </a>
  </div>

  <!-- CONTACTO  -->
  <section class="contact-section">

    <div class="contact-row">

      <div class="contact-card">
        <h3>■ JEFA DE DIVISIÓN</h3>
        <p class="name">Mtra. Yolanda del Carmen Estrella Pérez</p>
        <p>E-mail: <a href="mailto:divisionif@itsescarcega.edu.mx">divisioniia@itsescarcega.edu.mx</a></p>
        <P> Telefono:9821183526 </P>
      </div>
      <!-- 
     <div class="contact-card">
        <h3>■ COORDINADORA</h3>
        <p class="name">Lic. Ana Dalia Antonio Ordoñez</p>
        <p>E-mail: <a href="mailto:coordinacionisc@itsescarcega.edu.mx">coordinacionisc@itsescarcega.edu.mx</a></p>
        <p> Telefono:9828291780</p>
      </div>  -->

    </div>

  </section>

</div>